var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-info-selector" }, [
    _c("div", { staticClass: "clearfix" }, [
      _c(
        "div",
        { staticClass: "yxtbiz-info-selector__wrapper clearfix" },
        [
          _c("yxt-input", {
            staticClass: "pull-left",
            staticStyle: { width: "240px" },
            attrs: { placeholder: "请输入资讯标题", searchable: "" },
            on: {
              search: function ($event) {
                return _vm.getNewsList(1)
              },
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.getNewsList(1)
              },
            },
            model: {
              value: _vm.params.keyword,
              callback: function ($$v) {
                _vm.$set(_vm.params, "keyword", $$v)
              },
              expression: "params.keyword",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_wrapper" },
        [
          _c(
            "yxt-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "news_table",
              staticStyle: { width: "100%" },
              attrs: { "row-key": "id", data: _vm.tableData },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _vm.multiple
                ? _c("yxt-table-column", {
                    attrs: {
                      "class-name": "table-selection-odd",
                      type: "selection",
                      "show-overflow-tooltip": false,
                      width: "42",
                    },
                  })
                : _vm._e(),
              _c("yxt-table-column", {
                attrs: { prop: "title", label: "资讯标题", "min-width": "200" },
              }),
              _c("yxt-table-column", {
                attrs: { prop: "publishTime", label: "创建时间", width: "166" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formatTime(scope.row.publishTime)) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              !_vm.multiple
                ? _c("yxt-table-column", {
                    attrs: { label: "操作", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "yxt-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.choose(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.id ===
                                        (_vm.newsTemp.length
                                          ? _vm.newsTemp[0].id
                                          : "")
                                        ? "取消选择"
                                        : "选择"
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      314703385
                    ),
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "empty_content",
                  attrs: { slot: "empty" },
                  slot: "empty",
                },
                [_vm._v("暂无数据")]
              ),
            ],
            1
          ),
          _c("news-pager", {
            staticClass: "clearfix",
            attrs: { pager: _vm.paging },
            on: { searchData: _vm.getNewsList },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }